module.exports = "<div class=\"g-signin2 google-login-button\" data-height=\"40\" data-width=\"265\" data-longtitle=\"true\">\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/lib/auth/auth-form/auth-google.component.html
// module id = 835
// module chunks = 0